var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-generic",class:_vm.clazz,attrs:{"id":_vm.id}},[_c('h1',[_vm._v(" "+_vm._s(_vm.title)+" "),_c('strong',[_vm._v(_vm._s(_vm.titleStrong))])]),_c('label',[_vm._v(_vm._s(_vm.subtitle))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }